// internal deps
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// constants
import { SCREEN_NAME, IMPRESSION_ACTIONS, CLICK_ACTIONS } from "@payment-client/analytics/constants";

export const onSimplLinkingFailedImpressionEvent = (
    paymentCode: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_SIMPL_LINKING_FAILED,
        label: paymentCode,
    });
};

export const payLaterMethodsImpressionEvent = (
    payLaterCode: string,
    message: string | undefined,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAYLATER_METHODS,
        context: message,
        label: payLaterCode,
    });
};
export const linkAccountImpressionEvent = (
    payLaterCode: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_LINK_ACCOUNT,
        label: payLaterCode,
    });
};
export const onLinkPayLaterClickEvent = (walletName: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_LINK_PAYLATER,
        label: walletName,
    });
};

export const onKeyFactStatementClickEvent = (
    payLaterCode: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_KEY_FACTS_STATEMENT,
        label: payLaterCode,
    });
};
